module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--33.b730a012.png";